import { createContext, useEffect, useMemo, useState } from "react";
import { readToken } from "../utils/DataService";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import { IReleaseItems } from "../interfaces/IReleaseItems";


export interface Visibility {
    name: string;
    show: boolean;
  }

export const MyContext = createContext<any>({});
export const getGlobalFilterKey = (product: string) => `globalFilter_${product}`;
type Children = {
    children: React.ReactNode;
  };

const MyContextStore: React.FC<Children> = ({ children }) => {
const[metricData,setMetricData]=useState<any>([]);
const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
const [user, setUser] = useState<any>({});
const [loading, setLoading] = useState<boolean>(true);
const [visibility, setVisibility] = useState<Visibility[]>([]);
const [workItemClicked,setWorkItemClicked] = useState<boolean>(false);
const [selectedInsightWorkItems, setSelectedInsightWorkItems] = useState<any>(null);
const [selectedProduct,setSelectedProduct] = useState<string>();
const [isJourneyView, setIsJourneyView] = useState(true);
const [isTargetEnabled, setIsTargetEnabled] = useState(true);
const [stateCategories, setStateCategories] = useState<string[]>([]);
const [selectedStateCategory, setSelectedStateCategory] = useState<string>(stateCategories[0]);
const [releaseDetails, setReleaseDetials] = useState<IReleaseItems[]>([]);
const [isCompareTargetVisible, setIsCompareTargetVisible] = useState(false);

const [globalFilters, setGlobalFilters] = useState(() => ({
    selectedStateCategory: stateCategories[0]
  }));

const navigate = useNavigate();

const providerValue = useMemo(
        () => ({
            metricData,
            setMetricData,
            isAuthenticated,
            setIsAuthenticated,
            user, 
            setUser,
            setLoading,
            loading,
            setVisibility,
            visibility,
            setWorkItemClicked,
            workItemClicked,
            setSelectedInsightWorkItems,
            selectedInsightWorkItems,
            selectedProduct,
            setSelectedProduct,
            setIsJourneyView,
            isJourneyView,
            isTargetEnabled,
            setIsTargetEnabled,
            stateCategories,
            setStateCategories,
            selectedStateCategory,
            setSelectedStateCategory,
            globalFilters,
            setGlobalFilters,
            releaseDetails,
            setReleaseDetials,
            isCompareTargetVisible,
            setIsCompareTargetVisible,
            setSessionId: (sessionId: string) => {
                sessionStorage.setItem("sessionId", sessionId);
            },
        }),
        [
            metricData,
            setMetricData,
            isAuthenticated,
            setIsAuthenticated,
            user, 
            setUser,
            setLoading,
            loading,
            setVisibility,
            visibility,
            setWorkItemClicked,
            workItemClicked,
            setSelectedInsightWorkItems,
            selectedInsightWorkItems,
            selectedProduct,
            setSelectedProduct,
            setIsJourneyView,
            isJourneyView,
            isTargetEnabled,
            setIsTargetEnabled,
            stateCategories,
            setStateCategories,
            selectedStateCategory,
            setSelectedStateCategory,
            globalFilters,
            setGlobalFilters,
            releaseDetails,
            setReleaseDetials,
            isCompareTargetVisible,
            setIsCompareTargetVisible,
        ]
    );
    useEffect(() => {
        const token = readToken();
        if (token) {
            const decoded = jwtDecode(token);

            // logout - if token is expired
            const expireAtStr = decoded?.exp;
            const currentTime = Math.floor(Date.now() / 1000);
            const expired = expireAtStr ? expireAtStr < currentTime : true;
            if(expired){
                sessionStorage.clear()
                setIsAuthenticated(false);
                setUser(null)
                navigate('/login')
            }else{
                setUser(decoded)
                setIsAuthenticated(true);
            }
        }else{
            setIsAuthenticated(false);
            setUser(null)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);


      useEffect(() => {
        if (!selectedProduct) return;
        const stored = localStorage.getItem(getGlobalFilterKey(selectedProduct));
        const parsed = stored ? JSON.parse(stored) : null;
        if (parsed?.selectedStateCategory) {
            setSelectedStateCategory(parsed.selectedStateCategory);
            setGlobalFilters(parsed);
          } else if (stateCategories.length > 0) {
            setSelectedStateCategory(stateCategories[0]);
            setGlobalFilters({ selectedStateCategory: stateCategories[0] });
          }
      }, [selectedProduct,stateCategories]);


      useEffect(() => {
        if (!selectedProduct || !selectedStateCategory) return;
        const updated = { ...globalFilters, selectedStateCategory };
        setGlobalFilters(updated);
        localStorage.setItem(getGlobalFilterKey(selectedProduct), JSON.stringify(updated));
      }, [selectedStateCategory, selectedProduct]);

    return <MyContext.Provider value={providerValue}>{children}</MyContext.Provider>;
};
export default MyContextStore;